import { render, staticRenderFns } from "./getDataSon.vue?vue&type=template&id=1f4c249b&"
import script from "./getDataSon.vue?vue&type=script&lang=js&"
export * from "./getDataSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports